import $ from 'jquery';
import loadGoogleMapsApi from './load-google-maps-api-facade';
import _escape from 'lodash';

/**
 * JSON style from https://mapstyle.withgoogle.com/
 */
const stylesArray = [
	{
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#f5f5f5"
		}
	  ]
	},
	{
	  "elementType": "labels.icon",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#616161"
		}
	  ]
	},
	{
	  "elementType": "labels.text.stroke",
	  "stylers": [
		{
		  "color": "#f5f5f5"
		}
	  ]
	},
	{
	  "featureType": "administrative.land_parcel",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#bdbdbd"
		}
	  ]
	},
	{
	  "featureType": "poi",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#eeeeee"
		}
	  ]
	},
	{
	  "featureType": "poi",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#757575"
		}
	  ]
	},
	{
	  "featureType": "poi.park",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#e5e5e5"
		}
	  ]
	},
	{
	  "featureType": "poi.park",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	},
	{
	  "featureType": "road",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#ffffff"
		}
	  ]
	},
	{
	  "featureType": "road.arterial",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#757575"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#dadada"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#616161"
		}
	  ]
	},
	{
	  "featureType": "road.local",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	},
	{
	  "featureType": "transit.line",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#e5e5e5"
		}
	  ]
	},
	{
	  "featureType": "transit.station",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#eeeeee"
		}
	  ]
	},
	{
	  "featureType": "water",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#c9c9c9"
		}
	  ]
	},
	{
	  "featureType": "water",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	}
];

const $locationsMaps = $( '.js-locations-map' );
$locationsMaps.each( function() {
	const $map = $( this ).find( '.js-locations-map__map' );
	const locations = $( this ).data( 'locations' );

	loadGoogleMapsApi().then( function( googleMaps ) {

		const map = new googleMaps.Map( $map[0], {
			zoom: 4,
			center: new googleMaps.LatLng( 39, -100 ),
			mapTypeId: googleMaps.MapTypeId.ROADMAP,
			styles: stylesArray,
		} );

		googleMaps.event.addListenerOnce( map, 'tilesloaded', function() {
			const infoWindow = new googleMaps.InfoWindow( {
				content: 'loading...',
				maxWidth: 400,
			} );

			const markers = [];

			locations.forEach( ( location ) => {
				const marker = new googleMaps.Marker( {
					position: new googleMaps.LatLng( location.location.lat, location.location.lng ),
					map: map,
					icon: {
						url: window.designstudio.stylesheetDirectoryUri + '/assets/images/icon/map-marker.png',
						scaledSize: new google.maps.Size( 27, 35 ),
					},
				} );

				markers.push( marker );

				googleMaps.event.addListener( marker, 'click', () => {
					infoWindow.close();
					infoWindow.setContent( `
						<div class="c-map__popup-container">
							<p class="c-map__popup-title">${_escape( location.title )}</p>
							<p>${_escape( location.content )}</p>
						</div>
					` );
					infoWindow.open( map, marker );
				} );
			} );

			// make markers fit in map
			const bounds = new googleMaps.LatLngBounds();
			markers.forEach( marker => {
				bounds.extend( marker.getPosition() );
			} );

			// expand bounds a little
			const extendPoint1 = new googleMaps.LatLng(
				bounds.getNorthEast().lat() + 0.01,
				bounds.getNorthEast().lng() + 0.01,
			);
			const extendPoint2 = new googleMaps.LatLng(
				bounds.getNorthEast().lat() - 0.01,
				bounds.getNorthEast().lng() - 0.01,
			);
			bounds.extend( extendPoint1 );
			bounds.extend( extendPoint2 );

			map.fitBounds( bounds );
		} );
	} ).catch( function( error ) {
		console.error( error );
	} );
} );
